<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <riden-logo />

          <h2 class="brand-text text-primary ml-1">
            Safeer
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Welcome to Safeer IT 👋
        </b-card-title>
        <b-card-text class="mb-2">
          Please update your password
        </b-card-text>

        <!-- form -->
        <validation-observer ref="newPasswordValidation">
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >
            <!-- password -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required|password"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="new-password"
                    v-model="password"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="new-password"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit buttons -->
            <b-button
              type="submit"
              variant="primary"
              block
              @click="validationForm"
            >
              Change Password
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardText,
  BCardTitle,
  BForm,
  BButton,
  BCard,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import RidenLogo from '@/layouts/components/Logo.vue'
import router from '@/router'

export default {
  components: {
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BForm,
    BButton,
    RidenLogo,
    ValidationProvider,
    ValidationObserver,
    BCard,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      // validation rulesimport store from '@/store/index'
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    if (!this.$store.getters['auth/isAuthenticated']) {
      router.push({ path: '/login' })
    }
  },
  methods: {
    ...mapActions({ updatePassword: 'auth/updatePassword' }),
    async validationForm() {
      const isValid = await this.$refs.newPasswordValidation.validate()
      if (isValid) {
        const userData = await this.updatePassword(this.password)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Password Changed',
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Your new password set successfully',
          },
        })
        this.$ability.update(userData.ability)
        localStorage.setItem('userData', JSON.stringify(userData))
        router.push({ path: '/' })
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
